import React, { useEffect } from 'react';
import { useBoolVariation, useInitializationStatus } from '@launchdarkly/react-sdk';

import { DARK_MODE_TOGGLE_FLAG_KEY, isLaunchDarklyConfigured } from './constants';

const LaunchDarklyDarkModeToggleGate = ({ children }: { children: React.ReactNode }) => {
  const isDarkModeToggleEnabled = useBoolVariation(DARK_MODE_TOGGLE_FLAG_KEY, false);

  if (!isDarkModeToggleEnabled) {
    return null;
  }

  return <>{children}</>;
};

export const DarkModeToggleGate = ({ children }: { children: React.ReactNode }) => {
  if (!isLaunchDarklyConfigured()) {
    return null;
  }

  return <LaunchDarklyDarkModeToggleGate>{children}</LaunchDarklyDarkModeToggleGate>;
};

const ForceLightModeSync = ({ onDisabled }: { onDisabled: () => void }) => {
  useEffect(() => {
    onDisabled();
  }, [onDisabled]);

  return null;
};

const LaunchDarklyDarkModeThemeSync = ({ onDisabled }: { onDisabled: () => void }) => {
  const { status } = useInitializationStatus();
  const isDarkModeToggleEnabled = useBoolVariation(DARK_MODE_TOGGLE_FLAG_KEY, false);
  const isLaunchDarklyReady = status !== 'initializing';

  useEffect(() => {
    if (!isLaunchDarklyReady) {
      return;
    }

    if (!isDarkModeToggleEnabled) {
      onDisabled();
    }
  }, [isLaunchDarklyReady, isDarkModeToggleEnabled, onDisabled]);

  return null;
};

export const DarkModeThemeSync = ({ onDisabled }: { onDisabled: () => void }) => {
  if (!isLaunchDarklyConfigured()) {
    return <ForceLightModeSync onDisabled={onDisabled} />;
  }

  return <LaunchDarklyDarkModeThemeSync onDisabled={onDisabled} />;
};
